import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LayoutActionLoadError } from '@shared/store/actions/layout.action';
import { NGXLogger } from 'ngx-logger';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { DestroyAction } from './destroy.actions';
import { DestroyService } from '../services/destroy.service';

@Injectable()
export class DestroyEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private destroyService: DestroyService
  ) {}

  destroyRequestList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DestroyAction.destroyRequestListRequest),
      tap((_) => this.logger.debug('@Effect [Destroy] Destroy Request List Request')),
      switchMap(({ payload }) => {
        return this.destroyService.getDestroyRequestList({ ...payload }).pipe(
          map((response) => {
            return DestroyAction.destroyRequestListResponse({ response });
          }),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });

  destroyRequestView$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DestroyAction.destroyRequestViewRequest),
      tap((_) => this.logger.debug('@Effect [Destroy] Destroy Request View Request')),
      switchMap(({ payload }) => {
        return this.destroyService.getDestroyRequestView({ ...payload }).pipe(
          map((response) => {
            return DestroyAction.destroyRequestViewResponse({ response });
          }),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });

  destroyList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DestroyAction.destroyListRequest),
      tap((_) => this.logger.debug('@Effect [Destroy] Destroy List Request')),
      switchMap(({ payload }) => {
        return this.destroyService.getDestroyList({ ...payload }).pipe(
          map((response) => {
            return DestroyAction.destroyListResponse({ response });
          }),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });

  destroyView$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DestroyAction.destroyViewRequest),
      tap((_) => this.logger.debug('@Effect [Destroy] Destroy View Request')),
      switchMap(({ payload }) => {
        return this.destroyService.getDestroyView({ ...payload }).pipe(
          map((response) => {
            return DestroyAction.destroyViewResponse({ response });
          }),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });
}
